/**
 * Flatten the prototype chain in order to please Redux that only allows
 * "plain objects".
 * @param {Action} action - Action to flatten
 * @return {Object} Plain object action
 */
export default function flattenPrototype(action) {
	let result = Object.assign({}, action);
	let current = Object.getPrototypeOf(action);

	while (current) {
		// eslint-disable-next-line no-loop-func
		Object.getOwnPropertyNames(current).forEach(key => {
			if (result[key] === undefined) {
				result[key] = current[key];
			}
		});
		current = Object.getPrototypeOf(current);
	}

	return result;
}
